import React from 'react'
import { Create, Datagrid, Edit, EditButton, List, Show, ShowButton, SimpleForm, SimpleShowLayout, TextField, TextInput } from 'react-admin'

const filters = [
  <TextInput source="uid" label="Uid" alwaysOn />,
  <TextInput source="name" label="Name" alwaysOn />
]

const ChainList = props => (
  <List {...props} filters={filters}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="uid" />
      <TextField source="name" />
      <TextField source="url" />
      <EditButton />
      <ShowButton />
    </Datagrid>
  </List>
)

const ChainEdit = props => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput disabled source="id" />
      <TextInput disabled source="uid" />
      <TextInput source="name" />
      <TextInput source="url" />
    </SimpleForm>
  </Edit>
)

const ChainCreate = props => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="uid" />
      <TextInput source="name" />
      <TextInput source="url" />
    </SimpleForm>
  </Create>
)

const ChainShow = props => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="uid" />
      <TextField source="name" />
      <TextField source="url" />
    </SimpleShowLayout>
  </Show>
)

export { ChainList, ChainEdit, ChainCreate, ChainShow }
